import { Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { NavbarPrimaryComponent } from '../../components/navbar-primary/navbar-primary.component';
import { FooterPrimaryComponent } from '../../components/footer-primary/footer-primary.component';
import {
  FinanceSection,
  FooterContentService
} from '../../services/footer-content.service';

@Component({
  selector: 'app-finance',
  imports: [RouterLink, NavbarPrimaryComponent, FooterPrimaryComponent],
  templateUrl: './finance.component.html',
  styles: `
    :host {
      height: 100vh;
      display: flex;
      flex-direction: column;
    }

    main {
      flex: 1;
      padding-top: 64px;
    }
  `
})
export class FinanceComponent {
  private readonly footerContent = inject(FooterContentService);

  buttonCollapsed: boolean[] = [];

  sections: FinanceSection[] = [];
  loading = true;
  error = false;

  constructor() {
    this.footerContent.getFinance().subscribe({
      next: (sections) => {
        this.sections = sections;
        this.loading = false;
      },
      error: () => {
        this.error = true;
        this.loading = false;
      }
    });
  }
}
